import { render, staticRenderFns } from "./uploadprocess.vue?vue&type=template&id=5bcef0a8&scoped=true&"
import script from "./uploadprocess.vue?vue&type=script&lang=js&"
export * from "./uploadprocess.vue?vue&type=script&lang=js&"
import style0 from "./uploadprocess.vue?vue&type=style&index=0&id=5bcef0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcef0a8",
  null
  
)

export default component.exports